import { render, staticRenderFns } from "./footer-link.vue?vue&type=template&id=94e31226&scoped=true&"
import script from "./footer-link.vue?vue&type=script&lang=js&"
export * from "./footer-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e31226",
  null
  
)

export default component.exports